import { bootstrapTenant } from '@octawash/shared';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App';
import './lib/i18n'; // setup i18next antes do App montar
import { initSentry, SentryErrorBoundary } from './lib/sentry';
import './index.css';

initSentry();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root não encontrado em index.html');

function FallbackErro({ error }: { error: unknown }) {
  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="text-2xl font-semibold">Algo deu errado</h1>
      <p className="text-muted-foreground max-w-md text-sm">
        Nossa equipe já foi notificada. Tente recarregar a página.
      </p>
      <pre className="bg-muted max-w-2xl overflow-auto rounded p-4 text-left text-xs">
        {error instanceof Error ? error.message : String(error)}
      </pre>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="bg-primary text-primary-foreground rounded px-4 py-2 text-sm"
      >
        Recarregar
      </button>
    </div>
  );
}

// Sprint H: bootstrap de tenant ANTES do app renderizar. Resolve custom
// domains via RPC. Sync para domínios OctaWash conhecidos.
const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

async function iniciar() {
  if (url && anonKey) {
    await bootstrapTenant({
      hostname: window.location.hostname,
      supabaseUrl: url,
      anonKey,
      fallbackTenant: import.meta.env.VITE_DEFAULT_TENANT_SUBDOMAIN ?? null,
    });
  }

  ReactDOM.createRoot(rootEl!).render(
    <React.StrictMode>
      <SentryErrorBoundary fallback={({ error }) => <FallbackErro error={error} />}>
        <App />
      </SentryErrorBoundary>
    </React.StrictMode>,
  );
}

void iniciar();
